module.exports = __webpack_public_path__ + "media/images/thorrel-usecase-abd5744924040882d0de3d00741f5fe3.png";